/**
 * search and replace name
 * logo
 * url
 * favicon
 * google analytics
 *
 */

// https://www.flaticon.com/search?word=logo

module.exports = {
  myContentInfo: {
    shortName: `the49ershub`,
    siteUrl: `https://www.the49ershub.com`,
    websiteTitle: `the49ersHub`,
    metaTagDescription: `the49ershub.com where we provide the latest news and stats.`,
  },
};
